import rtk, { _ } from 'rtk';
import { createActionsHook } from 'rtk/react';
import { addListenerAction, removeListenerAction } from 'rtk/actions';
import { name } from './constants';

const { createActions, createThunks } = rtk(name);

import { subscribe as sub } from '@rails/cable';

const resourceActions = createActions({
  incomingMessage: (subscription, message) => _({ subscription, message }),
  subscriptionLost: ({ event, type, id }) => _({ event, type, id }),

  unsubscribe: (identifier) => _({ identifier }),
});

const resourceApi = createThunks({
  subscribe: (subscription, { dispatch, getState }) => {
    return new Promise((resolve, reject) =>
      sub(
        { channel: 'ResourceChannel', ...subscription },
        {
          onConnected({ reconnected }) {
            if (!reconnected) {
              resolve({ identifier: this.identifier });
            }
          },
          onDisconnected({ willAttemptReconnect }) {
            if (!willAttemptReconnect) {
              dispatch(subscriptionLost(subscription));
            }
          },
          onRejected() {
            reject(new Error('Cant connect'));
          },
          onReceived(message) {
            dispatch(incomingMessage(subscription, message));
          },
        },
      ),
    );
  },

  addListener: ({ action, effect }, { dispatch, getState }) => {
    dispatch(addListenerAction({ actionCreator: action, effect }));
  },
  removeListener: ({ action, effect }, { dispatch, getState }) => {
    dispatch(removeListenerAction({ actionCreator: action, effect }));
  },
});

// RTK-AUTOEXPORT
// ---- actions ---------
export const { incomingMessage, subscriptionLost, unsubscribe } =
  resourceActions;

export const useResourceActions = createActionsHook(resourceActions);
// ---- thunks ---------
export const { subscribe, addListener, removeListener } = resourceApi;

export const useResourceApi = createActionsHook(resourceApi);
